import { useState } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import funcSleep from "../../../components/funcSleep"
import modalStyles from "../styles/modalEmitirVarios.module.css"
import IconDraft from "../../../img/home/icon-draft"
import IconError from "../../../img/home/icon-error"
import { ApiEndpoints, reqPostDownloadFile, reqPostNew } from "../../../config/apiClient"
import IconDownload from "../../../img/home/icon-download"
import { toast } from "react-toastify"
import { getCookie } from "../../../config/cookies"
import IconFileError from "../../../img/home/icon-fileError"
import dayjs from "dayjs"

interface iPropsModal {
    show: boolean,
    handleClose: any,
    notas: any[],
}

//create your forceUpdate hook
function useForceUpdate() {
    // eslint-disable-next-line
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
}

export default function NfModalEmissaoVarios({show, handleClose, notas}: iPropsModal) {

    const [notasEmitir, setNotasEmitir] = useState<any[]>([])
    const [emitindoNotas, setEmitindoNotas] = useState<boolean>(false)
    const [qtdNotasProgresso, setQtdNotasProgresso] = useState<number>(0)
    const forceUpdate = useForceUpdate();

    async function handleCloseButton() {
        setEmitindoNotas(false)
        setNotasEmitir([])
        setQtdNotasProgresso(0)
        handleClose()
    }

    async function handleEmitirNotas() {
        if (!window.confirm("Deseja emitir as notas selecionadas?")) {
            return
        }

        setQtdNotasProgresso(0)

        let notasAux = []
        for (let reg of notas) {
            notasAux.push({
                status: "Emitindo",
                msg: "Emitindo...",
                error: null,
                nota: reg.nota
            })
        }
        setNotasEmitir(notasAux)

        setEmitindoNotas(true)
        await funcSleep(500)

        await handleEmitirNotasRecursivo(notasAux, 0)

        await funcSleep(500)
        setEmitindoNotas(false)
    }

    async function handleCancelarNotas() {
        // setCancelarNotas(true)
        // forceUpdate()
        var button:any = document.getElementById("btnCancelarLoteNotas")
        button.setAttribute("disabled", "true")
    }

    async function handleEmitirNotasRecursivo(notasAux:any[], qtdNotasProgressoAux:number):Promise<any> {

        let notaEmitir:any = {}
        for (let reg of notasAux) {
            if (reg.status === "Emitindo") {
                notaEmitir = reg
                break
            }
            continue
        }

        if (Object.values(notaEmitir).length === 0) {
            return
        }

        var button:any = document.getElementById("btnCancelarLoteNotas")
        if (button.disabled) {
            notaEmitir = {
                status: "Emitir",
                msg: "Emitir",
                error: null,
                nota: notaEmitir.nota
            }
        } else {
            await funcSleep(1000)
            notaEmitir = await emitirNota(notaEmitir)
        }

        for (let idx in notasAux) {
            if (notasAux[idx].nota.id_nota === notaEmitir.nota.id_nota) {
                notasAux[idx] = notaEmitir
                break
            } else {
                continue
            }
        }
        setNotasEmitir(notasAux)
        qtdNotasProgressoAux = qtdNotasProgressoAux + 1
        setQtdNotasProgresso(qtdNotasProgressoAux)
        console.log(notasAux)
        forceUpdate()

        let notasPendenteParaEnviar = false
        for (let reg of notasAux) {
            if (reg.status === "Emitindo") {
                notasPendenteParaEnviar = true
                break
            }
        }

        if (notasPendenteParaEnviar) {
            return await handleEmitirNotasRecursivo(notasAux, qtdNotasProgressoAux)
        }

        return

    }

    async function emitirNota(notaDados: any):Promise<any> {
        const id_nota = notaDados.nota.id_nota
        let nota = notaDados
        
        const api = await reqPostNew(ApiEndpoints.nfsEmissao, {id_nota: id_nota})
        if (api.status === 200) {
            nota = api.data
        } else {
            console.log(api)
            if (api.status === 400 && api.data.message === "NF já foi lançada!") {
                nota = {
                    status: "OK",
                    msg: "Nota já foi lançada!",
                    error: null,
                    nota: nota.nota
                }
            } else {
                nota = {
                    status: "ERRORAPP",
                    msg: "Erro no App, verifique com o suporte ou tente novamente mais tarde!",
                    error: null,
                    nota: nota.nota
                }
            }
        }

        return nota
    }

    return (
        <Modal
            show={show}
            onHide={() => {handleCloseButton()}}
            backdrop="static"
            keyboard={false}
            size="xl"
            id="modal_nf_emitir_varios"
        >
            <Modal.Header closeButton>
                <Modal.Title>Emitir NFs Selecionadas:</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: "flex", alignContent: "center", alignItems: "center" }}>
                    <Button variant="success" disabled={emitindoNotas} onClick={() => { handleEmitirNotas() }} style={{display: "inline"}}>Emitir Notas</Button>
                    <Button id="btnCancelarLoteNotas" variant="danger" disabled={false} onClick={() => { handleCancelarNotas() }} style={{display: emitindoNotas ? "inline" : "none", marginLeft: "15px"}}>Cancelar</Button>
                    <p style={{display: "inline", marginLeft: "10px"}}>({notas.length}) Notas Selecionadas</p>
                    { emitindoNotas && ( <div style={{display: "flex", marginLeft: "15px" }}><br></br><LoadingWidget mensagem="Aguarde, emitindo Notas" qtdEmitido={qtdNotasProgresso} qtdTotal={notas.length} /></div> ) }
                </div>

                <br></br>
                <ListaNotas notasEmitir={notasEmitir.length === 0 ? notas : notasEmitir} />

                <br></br>
                {
                    qtdNotasProgresso === notas.length &&
                    <BtnDownloadTodasNf notas={notasEmitir} />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {handleCloseButton()}}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )

}

function ListaNotas(props:any) {
    const [showModalXMLError, setShowModalXMLError] = useState<boolean>(false)
    const [XMLModalError, setXMLModalError] = useState<any>(false)

    return (
        <div id="notas_ha_emitir">
            <ModalMessageXMLError
                show={showModalXMLError}
                onHide={() => setShowModalXMLError(false)}
                xml={XMLModalError}
            />
            {
                props.notasEmitir.map((reg:any, idx:any) => {
                    return (
                        <div key={idx}>
                            <div className={modalStyles.notas_ha_emitir_item}>
                                <NotaIcon status={reg.status} />
                                <p>ID#{reg.nota.id_nota} {reg.nota.valor_servicos} | {reg.nota.id_cliente.nome} | {dayjs(reg.nota.data_servico).format("DD/MM/YYYY")} Situação {reg.nota.cod_serv.iss_incidencia_municipio_prestador === 0 ? 'Tributada' : 'Retido'}</p>
                                <BtnDownloadNf reg={reg} />
                                {
                                    reg.status === "ERROR" &&
                                    <div className="div-row">
                                        <div className="div-row" style={{cursor: "pointer"}} onClick={() => {
                                            setXMLModalError(reg)
                                            setShowModalXMLError(true)
                                        }}>
                                            <IconFileError className={modalStyles.iconFileError} />
                                            <p style={{marginLeft: "0px", fontWeight: 'bold'}}>Clique para ver os Erros</p>
                                        </div>
                                    </div>
                                }
                            </div>
                            
                        </div>
                    )
                })
            }
        </div>
    )
}

interface iPropsBtnDownload {
    reg: any
}
function BtnDownloadNf({reg}: iPropsBtnDownload) {

    const [downloading, setDownloading] = useState<boolean>(false)

    async function handleDownload() {
        let dadosDownload = {
            id_nota: reg.nota.id_nota,
            ambiente: reg.nota.ambiente.ambiente,
            codigo_verificacao: reg.nota.codigo_verificacao,
            tipo_arquivo: "pdf",
        }
        setDownloading(true)
        await download(dadosDownload, reg.nota)
    }

    async function download(dadosDownload:any, nfDados:any) {
    
        return new Promise(function (resolve, reject) {
            var token = getCookie('token')
            var id_usuario = getCookie('id_user')
            let request = new XMLHttpRequest();
        
            request.responseType = "blob";
            request.open("POST", dadosDownload.tipo_arquivo === "pdf" ? ApiEndpoints.nfsDownloadPDF.endpoint : ApiEndpoints.nfsDownloadXML.endpoint, true)
            request.setRequestHeader("Content-Type", "application/json")
            request.setRequestHeader("Authorization", `Bearer ${token}`)
            request.setRequestHeader("id_usuario", id_usuario)
            request.send(JSON.stringify(dadosDownload))
        
            request.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const imageURL = window.URL.createObjectURL(this.response)
                    const anchor = document.createElement("a")
                    anchor.href = imageURL
                    console.log(nfDados)
                    let cidade = ""
                    if (nfDados.cod_cidade !== null) {
                        cidade = ` (${nfDados.cod_cidade.nome}-${nfDados.cod_cidade.uf})`
                    }
                    let valor:string = ""
                    if (nfDados.valor_base !== null) {
                        valor = nfDados.valor_base
                    }
                    if (valor === "") {
                        valor = nfDados.valor_servicos
                        valor = valor.replaceAll(",", "")
                    }
                    anchor.download = `NFe ${nfDados.numero_nf}${cidade} - ${valor} - ${nfDados.id_cliente.nome}.${dadosDownload.tipo_arquivo === 'pdf' ?'pdf' : 'xml'}`
                    document.body.appendChild(anchor)
                    anchor.click()
                    toast.success('Download realizado com sucesso!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setDownloading(false)
                    resolve('')
                } else if (this.status === 401 || this.status === 400) {
                    toast.error('Erro Download!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setDownloading(false)
                    resolve('')
                }
            }
        })
    
    }

    return (
        <div className="div-row">
            {
                reg.status === "OK" &&
                <div className="div-row" style={{cursor: "pointer"}} onClick={() => {
                    if (!downloading) {
                        handleDownload()
                    }
                }}>
                    { downloading && <Spinner animation="border" role="status" size="sm" style={{marginLeft: "10px"}}></Spinner> }
                    { !downloading && <IconDownload className={modalStyles.iconDownload} /> }
                    <p style={{marginLeft: "10px", fontWeight: 'bold'}}>Download PDF</p>
                </div>
            }

            {
                reg.status === "ERRORAPP" &&
                <p style={{marginLeft: "10x"}}>Download não disponível. {reg.msg}</p>
            }
        </div>
    )
}

function BtnDownloadTodasNf(props:any) {
    const [downloading, setDownloading] = useState<boolean>(false)

    async function handleDownload() {
        const notasAux:any[] = props.notas
        const notas = notasAux.filter((reg) => reg.nota.emitido === 1)

        console.log(`TODAS NFS`)
        console.log(notas)

        if (notas.length === 0) {
            toast.warning(`Não há notas emitidas para download!`, {
                containerId: 1,
                position: 'bottom-center',
                theme: 'dark'
            })
            return
        }

        setDownloading(true)
        const lista_arquivos = await baixarListaArquivos(notas)
        if (lista_arquivos.length === 0) {
            toast.error('Não foi possível realizar o download, verifique com o suporte ou entre em contato mais tarde!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setDownloading(false)
            return
        }
        console.log(lista_arquivos)
        
        const downloadDados = {
            paths: lista_arquivos
        }
        let arquivo = `Notas-Fiscais.zip`
        let apiDownload = await reqPostDownloadFile(ApiEndpoints.nfsDownloadLista, downloadDados, arquivo)

        if (apiDownload.status === 200) {
            toast.success('Download realizado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Não foi possível realizar o download, verifique com o suporte ou entre em contato mais tarde!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setDownloading(false)

    }

    async function baixarListaArquivos(notas:any[]):Promise<any[]> {
        let arquivos:string[] = []

        for (let reg of notas) {
            let dadosDownload = {
                id_nota: reg.nota.id_nota,
                ambiente: reg.nota.ambiente.ambiente,
                codigo_verificacao: reg.nota.codigo_verificacao,
                tipo_arquivo: "pdf",
            }
            let api = await reqPostNew(ApiEndpoints.nfsDownloadPath, dadosDownload)

            if (api.status === 200) {
                arquivos.push(api.data.message)
            }
        }

        return arquivos
    }

    return (
        <div className="dic-row">
            <div className="div-row" style={{cursor: "pointer", width: "fit-content"}} onClick={() => {
                if (!downloading) {
                    handleDownload()
                }
            }}>
                { downloading && <Spinner animation="border" role="status" size="sm" style={{marginLeft: "10px"}}></Spinner> }
                { !downloading && <IconDownload className={modalStyles.iconDownload} /> }
                <p style={{marginLeft: "10px", fontWeight: 'bold'}}>Download Todas NF (PDF)</p>
            </div>
        </div>
    )
}

function NotaIcon(props:any) {

    let icon:any = ""

    if (props.status === "Emitindo") {
        icon = <Spinner animation="border" role="status" size="sm" style={{marginRight: "10px"}}></Spinner>
    }

    if (props.status === "OK") {
        icon = <IconDraft className={modalStyles.iconDraft} />
    }

    if (props.status === "ERROR") {
        icon = <IconError className={modalStyles.iconError} />
    }

    if (props.status === "ERRORAPP") {
        icon = <IconError className={modalStyles.iconErrorApp} />
    }

    return (
        icon
    )
}

function LoadingWidget(props:any) {
    return (
        <div className="div-row">
            <Spinner animation="border" role="status">
            <span className="visually-hidden"></span>
            </Spinner>
            <p style={{marginLeft: "10px", fontWeight: 'bold'}}>{props.mensagem} {props.qtdEmitido}/{props.qtdTotal} ...</p>
        </div>
    )
}

function ModalMessageXMLError(props:any) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            // centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <b>Erro</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { props.show &&
                    <div>
                        <a href={`/nfs?id_empresa=${props.xml.nota.id_empresa.id_empresa}&id_nota=${props.xml.nota.id_nota}`} target="_blank" rel="noreferrer">Ir para nota</a>
                        <br></br>
                    </div>
                }
                <textarea id="modal_msg_xml_erro" className='form-control' style={{height: "512px"}} value={props.xml.error} readOnly></textarea>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
